import type {
  Devices,
  QueryRequest,
  ResponseError,
} from '@rtkwlf/asset-data-service';
import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import { useOrganizationContext } from '@packages/legacy/organization-context';

import { useAssetDataServiceApi } from '../../use-asset-data-service-api';

export const getAssetsDevicesQueryKey = (
  organizationId: string,
  params: QueryRequest,
) => {
  return [organizationId, 'ads', 'assets', 'query-devices', params];
};

type Options<T> = Omit<
  UseQueryOptions<Devices, ResponseError, T>,
  'queryFn' | 'queryKey'
>;

export const useAssetsDevices = <T = Devices>(
  params: QueryRequest,
  options?: Options<T>,
) => {
  const api = useAssetDataServiceApi();
  const { id } = useOrganizationContext().selectedOrganization;

  return useQuery({
    queryKey: getAssetsDevicesQueryKey(id, params),
    queryFn: () =>
      api.queryDevices({
        organizationId: id,
        queryRequest: params,
      }),
    ...options,
  });
};
